import { Box, Typography } from '@material-ui/core';
import React, { Component } from 'react';
import CardPage from '../../../commonModules/layouts/CardPage';

class PageAdmin extends Component {
    state = {  }
    render() {
        return (
            // <Box>
            //     <Typography variant="h5" >
            //         {this.props.title}
            //     </Typography>
            //     <Box>
            //         {this.props.children}
            //     </Box>
            // </Box>

            <CardPage
                title={this.props.title}
                config
            >
                {this.props.children}
            </CardPage>
        );
    }
}

export default PageAdmin;